import {FC, useCallback} from 'react';
import {useTranslation} from '../../hooks/useTranslation';
import {Title} from '../../components/Title';
import {Subtitle} from '../../components/Subtitle';
import {Button} from '../../components/Button';
import {useEditor} from '../../providers/EditorContext';
import {TemplateCard} from '../../components/TemplateCard';

import styles from './styles.module.scss';
import {useNavigate} from 'react-router-dom';

export const SelectTemplate: FC = () => {
    const translate = useTranslation();
    const {templates, selectTemplate, selectedTemplate} = useEditor();

    const navigate = useNavigate();

    const goToNextStep = useCallback(() => {
        navigate('/editor');
    }, [navigate]);

    const onTemplateSelect = useCallback((templateId: string) => {
        selectTemplate(templateId);
        goToNextStep();
    }, [goToNextStep, selectTemplate]);

    return (
        <div className={styles.outerWrapper}>
            <div className="header">
                <Title text={translate('selectTemplateTitle')}/>
                <Subtitle text={translate('selectTemplateSubtitle')}/>
            </div>

            <div className={styles.templateWrapper}>
                {templates.map((template) => (
                    <TemplateCard
                        key={template}
                        onClick={() => onTemplateSelect(template)}
                        template={template}
                        selected={selectedTemplate === template}
                    />
                ))}
            </div>

            <div className="footer">
                <div className="footer-content">
                    <div></div>
                    <Button
                        disabled={!selectedTemplate}
                        text={translate('buttonNext')}
                        onClick={goToNextStep}
                    />
                </div>
            </div>
        </div>
    );
};
